import { render, staticRenderFns } from "./QrCode.vue?vue&type=template&id=8466f24c&scoped=true&"
import script from "./QrCode.vue?vue&type=script&lang=ts&"
export * from "./QrCode.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8466f24c",
  null
  
)

export default component.exports